import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ProcessConfig } from 'src/app/shared/interfaces/process-config.interface';
import { Evaluated360User } from '../../_interfaces/360-evaluation-user.interface';
import { ModalController, ToastController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { ConfirmModalComponent } from 'src/app/shared/modals/confirm-modal/confirm-modal.component';
import { Evaluation360Service } from '../../360-evaluation.service';
import { ThreeSixtyEvaluationStatus } from 'src/app/360-evaluation/_interfaces/360-evaluation-status';

type Evaluated360UserView = Evaluated360User & { selectedToRemoval: boolean };
@Component({
    selector: 'app-remove-excess-users-modal',
    templateUrl: './remove-excess-users-modal.component.html',
    styleUrls: ['./remove-excess-users-modal.component.scss'],
})
export class RemoveExcessUsersModalComponent extends BaseClass implements OnInit, OnDestroy {

    @Input() set config(value: ProcessConfig) {
        this.evaluationLimit = value.threeSixtyEvaluationLimit;
        this.evaluationLimitInHours = value.threeSixtyEvaluationTimespanInHours;
        this.processConfig = value;

        this.selectionEndDate = new Date(this.processConfig.startDate || new Date());
        this.selectionEndDate.setHours(this.selectionEndDate.getUTCHours() + this.evaluationLimitInHours);
        this.translateMessages();
    };

    @Input() set users(users: Evaluated360User[]) {
        this.usersView = users.map(user => ({ ...user, selectedToRemoval: false })).filter(user => user.isManagerEvaluation === false);
        this.excedentUsers = this.usersView.length - this.evaluationLimit;
    }
    @Input() cycleId?: number;

    public processConfig: ProcessConfig;

    //messages to show in the template with placeholders replaced
    public evaluatorsLimitWarningMessage = "";
    public evaluatorsLimitImportantMessage = "";
    public evaluatorsLimitInfoSelectMessage = "";


    public evaluationLimit: number = 0;
    public evaluationLimitInHours: number = 0;
    public usersView: Evaluated360UserView[] = [];
    public excedentUsers: number = 0;
    public selectionEndDate: Date = new Date();
    private _isUserQuantityOk: boolean = false;
    public ThreeSixtyEvaluationStatus = ThreeSixtyEvaluationStatus;
    public selectedToRemoval: string[] = [];
    public allSelected: boolean = false;
    public partialSelected: boolean = false;
    public isLoading: boolean = false;
    public currentLanguage?: string;

    constructor(
        private _modalController: ModalController,
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _evaluationService: Evaluation360Service,
    ) {
        super(_toastController, _translationService);
        this.currentLanguage = _translationService.getSelectedLanguage();

        _translationService.languageChanged$.subscribe((lang) => {
            this.currentLanguage = lang;
            this.translateMessages();
        });
    }



    ngOnInit() {
        this.translateMessages();
    }

    private translateMessages() {
        //Atenção: Você recebeu mais de {{evaluationLimit}} solicitações de avaliação, excedendo o limite permitido. Por isso, será necessário recusar {{excedentUsers}} avaliações antes de iniciar o processo e realizar as demais.
        this.evaluatorsLimitWarningMessage = this._translationService.getTranslation('360evaluation.evaluatorsLimit.warningMessage');
        this.evaluatorsLimitWarningMessage = this.evaluatorsLimitWarningMessage
            .replace("{{evaluationLimit}}", this.evaluationLimit.toString())
            .replace("{{excedentUsers}}", this.excedentUsers.toString());

        //Importante: Você tem {{evaluationLimitInHours}} horas, até o dia {{selectionEndDate}}, para iniciar a etapa de Avaliação 360. Esse prazo é essencial para que os gestores dos colaboradores cujas avaliações foram recusadas tenham tempo suficiente para selecionar novos avaliadores e para que você possa avançar para as próximas etapas.
        this.evaluatorsLimitImportantMessage = this._translationService.getTranslation('360evaluation.evaluatorsLimit.importantMessage');
        this.evaluatorsLimitImportantMessage = this.evaluatorsLimitImportantMessage
            .replace("{{evaluationLimitInHours}}", this.evaluationLimitInHours.toString())
            .replace("{{selectionEndDate}}", this.selectionEndDate.toLocaleDateString(this.currentLanguage));

        //Selecione {{excedentUsers}} avaliações e recuse-as para iniciar as avaliações desta etapa
        this.evaluatorsLimitInfoSelectMessage = this._translationService.getTranslation('360evaluation.evaluatorsLimit.infoSelectMessage');
        this.evaluatorsLimitInfoSelectMessage = this.evaluatorsLimitInfoSelectMessage
            .replace("{{excedentUsers}}", this.excedentUsers.toString());
    }

    ngOnDestroy(): void {
        this.dismiss();
    }

    public changeCheckbox(userId: string, selected: boolean) {

        if (selected) {
            this.selectedToRemoval.push(userId);
        } else {
            this.selectedToRemoval = this.selectedToRemoval.filter(id => id !== userId);
        }

        if (this.selectedToRemoval.length === this.usersView.length) {
            this.allSelected = true;
            this.partialSelected = false;
        } else if (this.selectedToRemoval.length > 0) {
            this.allSelected = false;
            this.partialSelected = true;
        }
        else {
            this.allSelected = false;
            this.partialSelected = false;
        }
    }

    public changeMasterCheckbox() {
        this.partialSelected = false;

        if (!this.allSelected) {
            this.selectAll();
        } else {
            this.deselectAll();
        }
    }

    public cleanSelection() {
        this.allSelected = false;
        this.partialSelected = false;
        this.deselectAll();
    }

    public deselectAll() {
        this.usersView.forEach(user => user.selectedToRemoval = false);
        this.selectedToRemoval = [];
    }

    public selectAll() {
        this.usersView.forEach(user => user.selectedToRemoval = true);
        this.selectedToRemoval = this.usersView.map(user => user.userId);
    }



    public async dismiss(): Promise<void> {
        await this._modalController.dismiss(
            { isUserQuantityOk: this._isUserQuantityOk },
            undefined,
            'removeExcessUsersModal'
        );
    }

    public async save() {
        console.log('save');
        this._isUserQuantityOk = this.selectedToRemoval.length == this.excedentUsers;
        if (this._isUserQuantityOk) {
            await this.createConfirmModal();
        }
    }

    private async createConfirmModal() {
        console.log('create confirm modal');

        const quantity = this.selectedToRemoval.length;

        let message = '';
        let msgBtnConfirm = '';
        if (quantity === 1) {
            message = this._translationService.getTranslation('360evaluation.evaluatorsLimit.confirm.messageSingular');
            msgBtnConfirm = this._translationService.getTranslation('360evaluation.evaluatorsLimit.confirm.confirmSingular');
        }
        else {
            //`Atenção: você está prestes a recusar {{quantity}} avaliações. Deseja seguir ?`
            message = this._translationService.getTranslation('360evaluation.evaluatorsLimit.confirm.messagePlural');
            message = message.replace("{{quantity}}", quantity.toString());
            msgBtnConfirm = this._translationService.getTranslation('360evaluation.evaluatorsLimit.confirm.confirmPlural');
        }

        const modalConfirm = await this._modalController.create({
            component: ConfirmModalComponent,
            cssClass: 'confirm-modal',
            componentProps: {
                title: this._translationService.getTranslation('360evaluation.evaluatorsLimit.confirm.title'),
                message: message,
                btnConfirmText: msgBtnConfirm,
            }
        });

        await modalConfirm.present();

        modalConfirm.onDidDismiss()
            .then((event) => {
                if (event.data) {
                    this.deleteEvaluations();
                }else{
                    this._isUserQuantityOk = false;
                }
            });
    }

    public deleteEvaluations(): void {
        this.isLoading = true;
        const userIds = this.selectedToRemoval;

        this._evaluationService.deleteEvaluations(this.cycleId, userIds)
            .subscribe((response) => {
                this.notifySuccess('360evaluation.evaluationDeleted');
                this.dismiss();
            }, (error) => {
                this.notifyError(error);
                this.isLoading = false;
            });
    }

}
